import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSr = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#007A33", d: "M0 0h900v600H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 120h900v360H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#C8102E", d: "M0 180h900v240H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M450 191.459l70.534 217.082-184.661-134.164h228.254L379.466 408.541z", fill: "#FFCD00" }));
const ForwardRef = forwardRef(SvgSr);
const Memo = memo(ForwardRef);
export default Memo;
